export default "__VITE_ASSET__Dlqw8h7$__"